import { getLink } from "../../../utils/utils";

import translator from "./translator";

const content = {
  esp: (
    `
    <h4 class="mb-3 bold text-center">Al la kalumniantaj Rusion</h4>

    <div class="poem">
      <p class="poem-block mb-3">
        Pro kio bruas vi en morna afekcio? <br/>
        Kial minacas anatemi al Rusio? <br/>
        Kio incitas vin? L’ afektoj de l’ popol’? <br/>
        Ne zorgu. Estas de la slava famili’ rutino, <br/>
        Antikva debatad’, solvebla de l’ destino, <br/>
        Ne solvos ĝin fremdlanda orakol’.
      </p>

      <p class="poem-block mb-3">
        Delonge jam interbatalas <br/>
        La slavaj gentoj en konkur’, <br/>
        Refoje inter si rivalas, <br/>
        Jen venk’, jen fuĝo en terur’.
      </p>

      <p class="poem-block mb-3">
        Ĉu restos post la kontraŭstaro <br/>
        Fidela rus’ aŭ vanta pol’? <br/>
        Ĉu slavaj rojoj kunfluiĝos en la rusa maro? <br/>
        Ĉu ĝi sekiĝos? Kies venkos vol’?
      </p>

      <p class="poem-block mb-3">
        La sangaj ĉartoj historiaj <br/>
        Por ni nur estas familiaj. <br/>
        Vi, fremdaj, ne komprenos ĝin. <br/>
        Do, iru for. Ne tuŝu nin.
      </p>

      <p class="poem-block mb-3">
        Por vi sensencas Kreml’ kaj Prago, <br/>
        Vin tiras nure la aŭdac’ <br/>
        De senelira lukta ago, <br/>
        Kaj vi nin hatas kun minac’. <br/>
        Respondu. Ĉu pro malkontento, <br/>
        Ke sur ruinoj de brulanta Moskovi’ <br/>
        Ni ne obeis al ordon’ impertinenta <br/>
        De tiu, kiun treme timis vi?
      </p>

      <p class="poem-block mb-3">
        Aŭ ĉar l’ idolon ni surtretis, <br/>
        Kiu timigis multajn regnojn kun arog’, <br/>
        Kaj niasange elaĉetis <br/>
        Eŭropan dignon kaj liberon el sufok’?
      </p>

      <p class="poem-block mb-3">
        Minacas vi per vort’ – sed provu en realo! <br/>
        Ĉu olda fortegul’, dormanta post batalo, <br/>
        Ne povos uzi plu la sabron kun honor’? <br/>
        Ĉu rusa car’ fariĝis jam senpova? <br/>
        Aŭ lukto kun Eŭrop’ por ni afero nova? <br/>
        Aŭ rusaj venkoj estas for? <br/>
        Aŭ pokas ni? Ĉu de la Permo
      </p>
    </div>
  `
  )
}

const itemName = {
  esp: 'Aleksandr Puŝkin'
}

const item = {
  itemlink: getLink(itemName.esp),
  esp: {
    itemName: itemName.esp,
    itemContent: content.esp,
    itemTranslator: translator.esp
  }
}

export default item;